import axios from 'axios'
//file:UserFunctions.js
//return:response
//import dependencies

export const fetchTimestamps = (destination_url) => {
    return axios
        .post(destination_url)
        .then(response =>{
            return response
        })
        .catch(err =>{
            console.log(err)
        })
}
